import PickupsService from './Pickups.service'

export default PickupsService
